import "./EmptyFoods.css";

import {
  MdRestaurantMenu,
  MdAdd,
} from "react-icons/md";

function EmptyFoods({ onAddFood }) {
  return (
    <div className="empty-foods">

      <div className="empty-icon">
        <MdRestaurantMenu />
      </div>

      <h2>No Menu Items Yet</h2>

      <p>
        Your menu is empty. Add your first food item
        to start receiving customer orders.
      </p>

      <button
        className="empty-add-btn"
        onClick={onAddFood}
      >
        <MdAdd />
        Add Food
      </button>

    </div>
  );
}

export default EmptyFoods;